import { render, staticRenderFns } from "./payman-info.vue?vue&type=template&id=5aaf36ae&scoped=true"
import script from "./payman-info.vue?vue&type=script&lang=js"
export * from "./payman-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaf36ae",
  null
  
)

export default component.exports